export default function TableD(props) {
  return <td className="px-3 py-2" {...props} />;
}
